export const potSeederAbi = [
    {
        'type': 'constructor',
        'inputs': [
            {
                'name': 'operator_',
                'type': 'address',
                'internalType': 'address'
            },
            {
                'name': 'admin',
                'type': 'address',
                'internalType': 'address'
            }
        ],
        'stateMutability': 'nonpayable'
    },
    {
        'type': 'function',
        'name': 'DEFAULT_ADMIN_ROLE',
        'inputs': [],
        'outputs': [
            {
                'name': '',
                'type': 'bytes32',
                'internalType': 'bytes32'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'SEEDER_ROLE',
        'inputs': [],
        'outputs': [
            {
                'name': '',
                'type': 'bytes32',
                'internalType': 'bytes32'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'getRoleAdmin',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'internalType': 'bytes32'
            }
        ],
        'outputs': [
            {
                'name': '',
                'type': 'bytes32',
                'internalType': 'bytes32'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'grantRole',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'internalType': 'bytes32'
            },
            {
                'name': 'account',
                'type': 'address',
                'internalType': 'address'
            }
        ],
        'outputs': [],
        'stateMutability': 'nonpayable'
    },
    {
        'type': 'function',
        'name': 'hasRole',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'internalType': 'bytes32'
            },
            {
                'name': 'account',
                'type': 'address',
                'internalType': 'address'
            }
        ],
        'outputs': [
            {
                'name': '',
                'type': 'bool',
                'internalType': 'bool'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'operator',
        'inputs': [],
        'outputs': [
            {
                'name': '',
                'type': 'address',
                'internalType': 'contract BlockpotOperator'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'renounceRole',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'internalType': 'bytes32'
            },
            {
                'name': 'callerConfirmation',
                'type': 'address',
                'internalType': 'address'
            }
        ],
        'outputs': [],
        'stateMutability': 'nonpayable'
    },
    {
        'type': 'function',
        'name': 'revokeRole',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'internalType': 'bytes32'
            },
            {
                'name': 'account',
                'type': 'address',
                'internalType': 'address'
            }
        ],
        'outputs': [],
        'stateMutability': 'nonpayable'
    },
    {
        'type': 'function',
        'name': 'seedDrawPot',
        'inputs': [
            {
                'name': 'draw',
                'type': 'address',
                'internalType': 'address'
            },
            {
                'name': 'nextPot',
                'type': 'bool',
                'internalType': 'bool'
            }
        ],
        'outputs': [],
        'stateMutability': 'payable'
    },
    {
        'type': 'function',
        'name': 'supportsInterface',
        'inputs': [
            {
                'name': 'interfaceId',
                'type': 'bytes4',
                'internalType': 'bytes4'
            }
        ],
        'outputs': [
            {
                'name': '',
                'type': 'bool',
                'internalType': 'bool'
            }
        ],
        'stateMutability': 'view'
    },
    {
        'type': 'function',
        'name': 'typeAndVersion',
        'inputs': [],
        'outputs': [
            {
                'name': '',
                'type': 'string',
                'internalType': 'string'
            }
        ],
        'stateMutability': 'pure'
    },
    {
        'type': 'event',
        'name': 'PotSeeded',
        'inputs': [
            {
                'name': 'sender',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            },
            {
                'name': 'draw',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            },
            {
                'name': 'amount',
                'type': 'uint256',
                'indexed': false,
                'internalType': 'uint256'
            },
            {
                'name': 'nextPot',
                'type': 'bool',
                'indexed': false,
                'internalType': 'bool'
            }
        ],
        'anonymous': false
    },
    {
        'type': 'event',
        'name': 'RoleAdminChanged',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'indexed': true,
                'internalType': 'bytes32'
            },
            {
                'name': 'previousAdminRole',
                'type': 'bytes32',
                'indexed': true,
                'internalType': 'bytes32'
            },
            {
                'name': 'newAdminRole',
                'type': 'bytes32',
                'indexed': true,
                'internalType': 'bytes32'
            }
        ],
        'anonymous': false
    },
    {
        'type': 'event',
        'name': 'RoleGranted',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'indexed': true,
                'internalType': 'bytes32'
            },
            {
                'name': 'account',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            },
            {
                'name': 'sender',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            }
        ],
        'anonymous': false
    },
    {
        'type': 'event',
        'name': 'RoleRevoked',
        'inputs': [
            {
                'name': 'role',
                'type': 'bytes32',
                'indexed': true,
                'internalType': 'bytes32'
            },
            {
                'name': 'account',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            },
            {
                'name': 'sender',
                'type': 'address',
                'indexed': true,
                'internalType': 'address'
            }
        ],
        'anonymous': false
    },
    {
        'type': 'error',
        'name': 'AccessControlBadConfirmation',
        'inputs': []
    },
    {
        'type': 'error',
        'name': 'AccessControlUnauthorizedAccount',
        'inputs': [
            {
                'name': 'account',
                'type': 'address',
                'internalType': 'address'
            },
            {
                'name': 'neededRole',
                'type': 'bytes32',
                'internalType': 'bytes32'
            }
        ]
    },
    {
        'type': 'error',
        'name': 'UnsupportedDraw',
        'inputs': [
            {
                'name': 'draw',
                'type': 'address',
                'internalType': 'address'
            }
        ]
    },
    {
        'type': 'error',
        'name': 'ZeroSeedAmount',
        'inputs': []
    }
] as const